import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.648 11.674a5.52 5.52 0 0 1 2.844 2.515 6.6 6.6 0 0 0 1.816-4.549c0-3.715-2.93-6.64-6.654-6.64C5.931 3 3 5.925 3 9.64c0 1.787.678 3.39 1.795 4.574a5.52 5.52 0 0 1 2.857-2.54 3.5 3.5 0 1 1 3.996 0zM21.05 20.2c.185.299.202.666.03.837a.583.583 0 0 1-.81 0l-5.51-5.497-.28.229c-1.313 1.072-2.978 1.657-4.75 1.657A7.705 7.705 0 0 1 2 9.712 7.705 7.705 0 0 1 9.73 2c4.283 0 7.73 3.44 7.73 7.712 0 1.767-.585 3.428-1.66 4.739l-.23.28 5.48 5.468zM9.65 11.3a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm-.003 5a6.47 6.47 0 0 0 4.068-1.43 4.503 4.503 0 0 0-8.135 0 6.47 6.47 0 0 0 4.067 1.43z"
});

var SvgBackgroundCheck = function SvgBackgroundCheck(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgBackgroundCheck;